export const HOTELS_TOGGLE_TEXT = "Hotels & resorts";
export const VACATION_RENTALS_TOGGLE_TEXT = "Vacation rentals";
